module.exports = __webpack_public_path__ + "static/media/dollar.cbeab270.svg";